import controller from './family-plan-master-buy-dialog.controller';

export default {
  controller,
  template: require('./family-plan-master-buy-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-master-buy-dialog/family-plan-master-buy-dialog.component.ts